// lot store inner constants
export const ACT_DOCVIEWPDFWIDTHSET = 'docViewPdfWidthSet';
export const ACT_DOCVIEWSHOWNAVIGATIONSET = 'docViewshowNavigationSet';
export const ACT_APPSET = 'loadAppSett';
export const ACT_CONFIG = 'loadConfig';
export const ACT_DOCCOLUMNS = 'saveDocumentColumns';
export const ACT_WORDWRAP = 'saveWordWrap';

export const GET_LOCALEGET = 'localeGet';
export const GET_APIURLGET = 'apiUrlGet';
export const GET_APIHOSTGET = 'apiHostGet';
export const GET_CURENTVERSIONGET = 'curentVersionGet';
export const GET_DOCVIEWPDFWIDTHGET = 'docViewPdfWidthGet';
export const GET_DOCVIEWSHOWNAVIGATIONGET = 'docViewshowNavigationGet';
export const GET_APPSET = 'getAppSett';
export const GET_CFG_WAITER = 'getConfigWaiter';
export const GET_STG_WAITER = 'getSettingsWaiter';
export const GET_SERV_VERS = 'getServerVersion';
export const GET_DOCCOLUMNS = 'getDocumentColumns';
export const GET_ISSHOWORGDOC = 'getIsShowOrgDocuments';
export const GET_WORDWRAP = 'getWordWrap';
export const GET_SERV_TIME = 'getServerTime';

export const MUT_LOCALESET = 'LocaleSet';
export const MUT_DOCVIEWPDFWIDTHSET = 'docViewPdfWidthSet';
export const MUT_DOCVIEWSHOWNAVIGATIONSET = 'docViewshowNavigationSet';
export const MUT_CFG = 'storeConfig';
export const MUT_APPSET = 'storeAppSett';
export const MUT_CLEAR_OLD_STATE = 'clearOldState';
export const MUT_SERV_VERS = 'setServerVersion';
export const MUT_DOCCOLUMNS = 'setDocumentColumns';
export const MUT_ISSHOWORGDOC = 'setIsShowOrgDocuments';
export const MUT_WORDWRAP = 'setWordWrap';
export const MUT_SERV_TIME = 'setServerTime';
